import React from 'react';
import createSVG from '../createSVG';

const DetailsIconBig = ({style}) => (
  <path style={style} fill="none" fillRule="evenodd" stroke="#6ED2A0" strokeWidth="3" strokeLinecap="round" d="M40.255 77.963c20.853 0 37.756-17.006 37.756-37.981C78.011 19.004 61.108 2 40.255 2 19.405 2 2.5 19.004 2.5 39.982c0 20.975 16.905 37.981 37.755 37.981zm26.886-11.321L109.5 109 67.141 66.642zM37.068 109h37.863m-37.863 0V44.8m0 0L74.931 2"/>
);

export default createSVG(DetailsIconBig);
